/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Applications_Find_JobsInputs */

const en_applications_find_jobs = /** @type {(inputs: Applications_Find_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find Jobs`)
};

const de_applications_find_jobs = /** @type {(inputs: Applications_Find_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stellen finden`)
};

const fr_applications_find_jobs = /** @type {(inputs: Applications_Find_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trouver des emplois`)
};

const es_applications_find_jobs = /** @type {(inputs: Applications_Find_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar empleos`)
};

const it_applications_find_jobs = /** @type {(inputs: Applications_Find_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trova lavori`)
};

const nl_applications_find_jobs = /** @type {(inputs: Applications_Find_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Banen zoeken`)
};

const pl_applications_find_jobs = /** @type {(inputs: Applications_Find_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Znajdź prace`)
};

const fi_applications_find_jobs = /** @type {(inputs: Applications_Find_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etsi työpaikkoja`)
};

const da_applications_find_jobs = /** @type {(inputs: Applications_Find_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find job`)
};

const sv_applications_find_jobs = /** @type {(inputs: Applications_Find_JobsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hitta jobb`)
};

/**
* | output |
* | --- |
* | "Find Jobs" |
*
* @param {Applications_Find_JobsInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const applications_find_jobs = /** @type {((inputs?: Applications_Find_JobsInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Applications_Find_JobsInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_applications_find_jobs(inputs)
	if (locale === "fr") return fr_applications_find_jobs(inputs)
	if (locale === "es") return es_applications_find_jobs(inputs)
	if (locale === "it") return it_applications_find_jobs(inputs)
	if (locale === "nl") return nl_applications_find_jobs(inputs)
	if (locale === "pl") return pl_applications_find_jobs(inputs)
	if (locale === "fi") return fi_applications_find_jobs(inputs)
	if (locale === "da") return da_applications_find_jobs(inputs)
	if (locale === "sv") return sv_applications_find_jobs(inputs)
	return en_applications_find_jobs(inputs)
});